import './App.css';
import { Container } from "@mui/material";
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Login from './pages/Login';
import Footer from './components/Footer';
import Register from './pages/Register';

import { useEffect, createContext, useState } from 'react'

import { Global, css } from "@emotion/react";

import UserInfo from './pages/UserInfo';
import Edit from './pages/Edit';
import Payment from './pages/Payment';
import dayjs from 'dayjs';

export const paymentRequirement = (e) => ['individual', 'corporate', 'lifetime', 'honorary'].includes(e);

export const imgPath =
  process.env.NODE_ENV === "production" ? "/assets/membership" : "";
export const base64Path =
  process.env.NODE_ENV === "production" ? "http://localhost:10079/wp-content/uploads/base64" : "/base64";

export const gasPath =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_GAS_PROD
    : process.env.REACT_APP_GAS_TEST;

export const prefix =
  process.env.NODE_ENV === "production" ? "" : `test-`;

export const membershipList = {
  invalid: `失効`,
  temporary: `仮`,
  supporting: `賛助`,
  individual: `個人`,
  corporate: `法人`,
  honorary: `名誉`,
  lifetime: `終身`,
}

export const nearExpiry = (expiry) => {
  if (!expiry || expiry === `` || expiry === `NA`) return
  return dayjs(expiry).diff(dayjs(), 'day') < 30 &&
    dayjs(expiry).diff(dayjs(), 'day') >= 0
}

export const nearExpiry90 = (expiry) => {
  if (!expiry || expiry === `` || expiry === `NA`) return
  return dayjs(expiry).diff(dayjs(), 'day') < 90 &&
    dayjs(expiry).diff(dayjs(), 'day') >= 0
}

export const isExpiry = (expiry) => {
  if (!expiry || expiry === ``) return
  const expiryDate = dayjs(expiry);
  const today = dayjs();
  return today.isAfter(expiryDate);
}

export const restPath =
  process.env.NODE_ENV === "production" ? "" : "http://localhost:10079";

export const TokenContext = createContext();

const GlobalStyles = () => (
  <Global
    styles={css`
        body {
          font-family: "Noto Sans JP", sans-serif;
          font-optical-sizing: auto;
          font-weight: normal;
          font-style: normal;
        }
`}
  />
);

function App() {
  const [token, setToken] = useState(null);
  useEffect(() => {
    // 🔹 ここで sessionStorage の値を初期化時に読み込む
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      setToken(JSON.parse(storedToken));
    }

    const fetchToken = async () => {
      try {
        const res = await fetch(`${restPath}/wp-json/custom/v1/token`);
        const { token } = await res.json();
        if (token) {
          setToken(token);
          sessionStorage.setItem("token", JSON.stringify(token));
        } else {
          console.log("Getting Token failed.");
        }
      } catch (err) {
        console.error("Token fetch failed:", err);
      }
    };

    fetchToken();
    const interval = setInterval(fetchToken, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <TokenContext.Provider value={token}>
      <BrowserRouter basename="/membership">
        <GlobalStyles />
        <div id='wrapper'>
          <Main></Main>
          <Footer />
        </div>
      </BrowserRouter>
    </TokenContext.Provider>
  );
}

const Main = () => {
  const storedData = sessionStorage.getItem("jacUserCore");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== '/' && storedData === null) {
      navigate('/');
    }
  }, [location.pathname, storedData, navigate]);

  return <Container maxWidth="sm" style={{ background: `#fff` }}>
    <Header />
    <main>
      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/user-info/" element={<UserInfo />}></Route>
        <Route path="/user-info/edit" element={<Edit />}></Route>
        <Route path="/register/" element={<Register />}></Route>
        <Route path="/payment/" element={<Payment />}></Route>
      </Routes>
    </main>
  </Container>
}

export default App;

